export default __webpack_public_path__ + "static/media/BUNDES_TELEFONBUCH.633518d5.png";